// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root__UhCtE","text":"NotFoundPage_text__HxXOL"};